'use strict';

var i18n = require('utils/i18n');
var Units = require('utils/units');
var Consts = require('consts');

var Strings = {};

Strings.getValueTypeClass = function (type) {
    if (type.indexOf('_') > 0) {
        type = type.split('_')[0];
    }
    return Consts.ValueTypeClass[type] || type;
};

// Compares two given URLs - ignoring parameters ('?').
Strings.compareURL = function (a, b) {
    if (a == undefined || b == undefined) {
        return false;
    }

    if (a.indexOf('?') != -1) {
        a = a.substring(0, a.indexOf('?'));
    }
    if (b.indexOf('?') != -1) {
        b = b.substring(0, b.indexOf('?'));
    }

    return a == b;
};

// Combines all arguments with '/' as separator.
// Stops at the first undefined argument.
Strings.joinURL = function () {
    var urlParts = [];

    for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg == undefined) {
            break;
        }
        urlParts.push(arguments[i]);
    }

    return urlParts.join('/');
};

// Combines the given dictionary (string -> value) into
// a URL parameter string. See unit tests for examples.
Strings.joinURLparameter = function (params) {
    if (params === undefined) {
        return '';
    }

    var sortedKeys = _.keys(params).sort();
    var result = '';

    _.each(sortedKeys, function (key) {
        if (params.hasOwnProperty(key)) {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                result += (result === '' ? '?' : '&') + key + '=' + params[key].toString().trim();
            }
        }
    });

    return result;
};

// Splits the given URL parameter string ('?a=x&b=y') into an
// object ({a: x, b: y}). See unit tests for examples.
Strings.splitURLparameter = function (request) {
    if (request === undefined || request === null) {
        return {};
    }

    request = request.trim();
    if (request.startsWith('?')) {
        request = request.substr(1);
    }
    if (request.length == 0) {
        return {};
    }

    var result = {};
    var parts = request.split('&');

    for (var i = 0; i < parts.length; ++i) {
        var p = parts[i].split('=');
        if (p.length == 2) {
            result[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
        }
    }

    return result;
};

// constructs a path out of the url. See unit tests for examples
Strings.urlToPath = function (route) {
    // construct path to file. Example for german language:
    // gateway/3/status-log" -> "/help/de_gateway_status-log.txt"
    route = route.replace(/\?.*/, ''); // removing URL parameters
    route = route.replace(/[a-z,A-Z]*\/[0-9]+\/analyze.*/g, 'meter_analyze'); // simplify analyze
    route = route.replace(/\/[0-9]+/, ''); // removing IDs
    route = route.replace(/\//g, '_'); // replacing '/' with '_'
    route = route.replace(/(-water|-[1-3]){1}/, '-1'); // replacing '-water, -1, -2, -3' with '-1'

    return '/help/' + i18n.language + '_' + route + '.json';
};

// Returns a search request URL fragment for the given input.
// Supports "special" commands, like "foo tags:X".
// See unit tests for more examples.
Strings.searchRequest = function (input) {
    var result = { search_text: '', type: '', status: '', tags: '', groups: '' };
    if (input === undefined || input === null) {
        return result;
    }

    input = input.trim();
    if (input.length == 0) {
        return result;
    }

    var specials = ['type', 'status', 'tags', 'groups'];
    var state = 'search_text';

    var isInQuotes = false;
    var isSpecialCommandAllowed = true;

    for (var i = 0; i < input.length; ++i) {
        if (isSpecialCommandAllowed && !isInQuotes) {
            var skip = false;

            // look-ahead: special entry?
            _.each(specials, function (s) {
                var idx = input.indexOf(s + ':', i);
                if (idx == i || (idx == i + 1 && input[i] == ' ')) {
                    state = s;
                    i += s.length + (idx == i + 1 ? 1 : 0);
                    skip = true;
                }
            });

            if (skip) {
                while (i + 1 < input.length && input[i + 1] == ' ') {
                    i += 1;
                }
                if (result[state].length != 0) {
                    result[state] = result[state].trim() + ',';
                }
                continue;
            }
        }
        if (state == 'search_text' && input[i] == '"') {
            // toggle quoting state and ignore character
            isInQuotes = !isInQuotes;
            continue;
        }

        isSpecialCommandAllowed = input[i] == ' ';
        result[state] += input[i];
    }

    _.each(result, function (value, key) {
        result[key] = value.trim();
    });
    return result;
};

Strings.containsSpecialChars = function (str) {
    var specialChars = ['"', "'"]; // extend as required
    for (var i = 0; i < specialChars.length; i++) {
        if (str.includes(specialChars[i])) {
            return true;
        }
    }
    return false;
};

// takes an int (or an int as string) and returns a string with length 2.
// 0   -> 00
// 1   -> 01
// 12  -> 12
// 123 -> 23
Strings.twoDigitsLeadingZero = function (number) {
    return ('00' + number).slice(-2);
};

// Returns the given number as fixed point decimal number with the specified
// number of digits after the decimal point.
// Examples: fixedPoint(123, 1) -> "12.3"
//           fixedPoint(123, 2) -> "1.23"
//           fixedPoint(120, 1) -> "12.0"
Strings.fixedPoint = function (number, digits, isSigned16Bit) {
    if (isSigned16Bit === true && number > 0x7fff) {
        // convert to signed integer
        number = -(0x10000 - number);
    }

    if (digits == 0) {
        return '' + number;
    }

    return '' + (number * Math.pow(10, -digits)).toFixed(digits);
};

// formats the value and unit, so that they are displayed appropriated (f.e. '1.2 kW' instead of '1200 W')
Strings.adjustUnits = function (value, unit, outputUnit) {
    outputUnit = outputUnit || Units.fitUnit([value], unit);
    var valueRec = Units.convert(value, unit, outputUnit);
    if (valueRec.err) {
        return {
            value: value,
            unit: unit || '',
        };
    }

    var value = Math.round(valueRec.value * 1000) / 1000;
    return {
        unit: outputUnit || '',
        value: value,
    };
};

var coilRegExp = /(.*?)-\(0\)\/(.*?)-\(1\)/;
var registerRegExp = /([/fptm])([^/fptm]+)/g;

var trunc = function (x) {
    return x - (x % 1);
};

Strings.formatCoilValue = function (value, type, format) {
    var vtc = Strings.getValueTypeClass(type);
    // no format? -> return value as-is
    if (format === undefined || format === '') {
        return value;
    }

    var coilFormats = format.match(coilRegExp);
    if (vtc === 'MBC' && coilFormats != null && (value == 0 || value == 1)) {
        return coilFormats[value + 1];
    }

    return undefined;
};

Strings.formatValue = function (value, type, format) {
    var vtc = Strings.getValueTypeClass(type);
    // no format? -> return value as-is
    if (format === undefined || format === '') {
        return value;
    }

    // coil?
    var formattedCoilValue = Strings.formatCoilValue(value, type, format);
    if (formattedCoilValue !== undefined) {
        return formattedCoilValue;
    }

    // register - replacement format?
    if ((vtc === 'MBR' || type === 'UNSPECIFIED') && format[0] === 'r') {
        var lookup = JSON.parse(format.substring(1));
        return lookup[value] || value;
    }

    // register - no replacement format?
    if ((vtc === 'MBR' || type === 'UNSPECIFIED' || type === 'WD' || type === 'DEVICE') && format[0] !== 'r') {
        var match;
        while ((match = registerRegExp.exec(format)) !== null) {
            if (match.index === registerRegExp.lastIndex) {
                registerRegExp.lastIndex++;
            }

            switch (match[1]) {
                case '/': {
                    // division
                    value = parseFloat(value) / match[2];
                    break;
                }
                case 'f': {
                    // fixed number of decimal places
                    value = parseFloat(value).toFixed(match[2]);
                    break;
                }
                case 'p': {
                    // left padding
                    var parts = match[2].split('-');
                    value = trunc(value).toString();
                    while (value.length < parts[1]) {
                        value = parts[0] + value;
                    }
                    break;
                }
                case 't': {
                    // template
                    value = value.toString();
                    var pos = value.length - 1;
                    var result = '';
                    // scan template backwards and replace # with char from value
                    for (var i = match[2].length - 1; i >= 0 && pos >= 0; i--) {
                        if (match[2][i] == '#') {
                            // take character from current value
                            result = value[pos] + result;
                            pos--;
                        } else {
                            // take character from template
                            result = match[2][i] + result;
                        }
                    }

                    value = result;
                    break;
                }
                case 'm': {
                    // value mapping
                    var mapping = JSON.parse(match[2]);
                    value = ((mapping[1] - mapping[0]) / 1000) * value + mapping[0];
                    break;
                }
            }
        }
        if (type === 'UNSPECIFIED') {
            value = parseFloat(value).toString(); // remove trailing zeros if we don't actually know the format
        }
    }

    return value;
};

Strings.formatAsciiBuffer = function (buffer) {
    var asciiString = '';
    for (var i = 0; i < buffer.length; i++) {
        // extract characters
        var hi = (buffer[i] & 0xff00) >> 8;
        var lo = buffer[i] & 0x00ff;

        // valid? -> append to string buffer
        asciiString += hi != 0 ? String.fromCharCode(hi) : '';
        asciiString += hi != 0 && lo != 0 ? String.fromCharCode(lo) : '';

        // zero termination? -> reached end of string
        if (hi * lo == 0) {
            break;
        }
    }
    return asciiString;
};

// Interprets the given list of values according to the specified format.
// Currently supported formats: 'ascii' and 'p-ascii'
Strings.formatAsciiValue = function (values, format) {
    if (!values || !values.length || values.length == 0) {
        // invalid parameters
        return '--';
    }

    switch (format) {
        case 'ascii':
            return Strings.formatAsciiBuffer(values);
        case 'h-ascii':
            // Return numbers as Hex-Ascii string.

            // Example: [9993, -26475] -> [9993, 39061] -> [0x2709, 0x9895] -> '27099895'
            var result = '';
            i = 0;
            while (i < values.length) {
                if (values[i] === undefined) {
                    return result;
                }

                // get value and convert to unsigned (if required)
                var v = values[i];
                if (v < 0) {
                    v = v + 65536;
                }

                // append current value as hex-string to the result
                result += v.toString(16);

                i++;
            }
            return result;

        case 'p-ascii':
            // Packed ASCII is a HART-specific 6-bit character code representing a subset
            // of the ASCII character code set. Produced by compressing four Packed ASCII
            // characters into three 8-bit bytes, Packed ASCII string must be a multiple
            // of 4 characters (3bytes) and must be padded out to the end of the data item
            // with space characters. For example 4 space characters at the end of a string
            // would appear as the 3 bytes: 0x82, 0x08, and 0x20.

            // The rule for converting from ASCII to Packed ASCII is just to remove bits 6
            // and 7 (two most significant).

            // The rules for conversion from packed ASCII back to ASCII are
            // (1) set bit 7 = 0 and
            // (2) set bit 6 = complement of packed ASCII bit 5.

            // input must be multiple of three 16-bit values -> otherwise invalid
            if (values.length % 3 != 0) {
                return '--';
            }

            // pre-processing (= unpack ascii)
            var packedBytes = [];

            // .. extract 6-bit compressed bytes
            var i = 0;
            while (i < values.length) {
                // process in three register steps

                // .. combine to two 32-bit integers
                var r1 = (values[i] << 16) + values[i + 1];
                var r2 = (values[i + 1] << 16) + values[i + 2];

                var decompress = function (value) {
                    return value + ((~value & 0x20) << 1);
                };

                // -> result in 8 compressed bytes
                packedBytes.push(decompress((r1 & 0xfc000000) >>> 26));
                packedBytes.push(decompress((r1 & 0x03f00000) >>> 20));
                packedBytes.push(decompress((r1 & 0x000fc000) >>> 14));
                packedBytes.push(decompress((r2 & 0x3f000000) >>> 24));
                packedBytes.push(decompress((r2 & 0x00fc0000) >>> 18));
                packedBytes.push(decompress((r2 & 0x0003f000) >>> 12));
                packedBytes.push(decompress((r2 & 0x00000fc0) >>> 6));
                packedBytes.push(decompress((r2 & 0x0000003f) >>> 0));

                // move to next three registers
                i += 3;
            }

            // .. combine to regular ascii buffer
            var unpackedValues = [];
            for (i = 0; i < packedBytes.length; i += 2) {
                unpackedValues.push((packedBytes[i] << 8) + packedBytes[i + 1]);
            }

            // return formated values
            return Strings.formatAsciiBuffer(unpackedValues);
    }

    // unknown format
    return '--';
};

// not available in ECMASCRIPT 5
Strings.endsWith = function (input, suffix) {
    return input.indexOf(suffix, input.length - suffix.length) !== -1;
};

Strings.meterManufacturer = function (numericalID) {
    var manID = '';
    var temp = numericalID;

    while (temp) {
        manID = String.fromCharCode((temp % 32) + 64) + manID;
        temp = Math.floor(temp / 32);
    }

    return manID;
};

Strings.copyToClipboard = function (str) {
    // adapted from: https://github.com/Chalarangelo/30-seconds-of-code#copytoclipboard-
    var el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';

    document.body.appendChild(el);

    var selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
    el.select();

    document.execCommand('copy');
    document.body.removeChild(el);

    if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
    }
};

// Expects array of continuous range of registers.
// Registers should have the form: {adress: ..., value: ...}
Strings.registersToString = function (registers) {
    var bytes = [];
    var result = '';

    for (var i = 0; i < registers.length; i++) {
        //append result until we encounter a NULL-character
        bytes[0] = parseInt(registers[i].value / 0x100);
        bytes[1] = registers[i].value % 0x100;

        for (var j = 0; j < bytes.length; j++) {
            if (bytes[j] === 0) {
                return result;
            }
            result += String.fromCharCode(bytes[j]);
        }
    }
};

Strings.isDataPoint = function (str) {
    return null != str.match(/^MB[RC]_[1-9]+[0-9]*$/);
};

module.exports = Strings;
